const FamilyTab = ({
  familyMembers,
  calculateAge,
  setShowFamilyModal,
  setSelectedFamilyMember,
  setShowEditFamilyModal,
  handleDeleteFamilyMember,
  darkMode
}) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h3 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-slate-800'}`}>Agregado Familiar</h3>
        <button
          onClick={() => setShowFamilyModal(true)}
          className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm hover:bg-blue-500 transition-colors"
          data-testid="add-family-member-btn"
        >
          + Adicionar Membro
        </button>
      </div>
      
      {familyMembers.length === 0 ? (
        <div className="text-center py-8">
          <p className={`mb-4 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Sem membros do agregado registados</p>
          <button
            onClick={() => setShowFamilyModal(true)}
            className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-500"
          >
            Adicionar Primeiro Membro
          </button>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {familyMembers.map((member, idx) => {
            const age = calculateAge(member.birth_date);
            const eligibleForChildBenefits = age !== null && age < 18;
            const eligibleForStudentBenefits = age !== null && age < 25;
            
            return (
              <div key={idx} className={`p-4 rounded-lg ${darkMode ? 'bg-slate-700/50' : 'bg-slate-100'}`}>
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <p className={`font-medium ${darkMode ? 'text-white' : 'text-slate-800'}`}>{member.name}</p>
                    <p className={`text-sm capitalize ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>{member.relationship}</p>
                  </div>
                  <div className="flex gap-1">
                    <button
                      onClick={() => { setSelectedFamilyMember(member); setShowEditFamilyModal(true); }}
                      className={`p-1.5 rounded text-white ${darkMode ? 'bg-slate-600 hover:bg-slate-500' : 'bg-slate-400 hover:bg-slate-300'}`}
                      data-testid={`edit-family-${member.member_id}`}
                    >
                      ✏️
                    </button>
                    <button
                      onClick={() => handleDeleteFamilyMember(member.member_id)}
                      className="p-1.5 rounded bg-red-600 hover:bg-red-500 text-white"
                      data-testid={`delete-family-${member.member_id}`}
                    >
                      🗑️
                    </button>
                  </div>
                </div>
                
                {member.birth_date && (
                  <div className={`mt-2 p-2 rounded ${darkMode ? 'bg-slate-800/50' : 'bg-slate-200'}`}>
                    <p className={`text-xs ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Data de Nascimento</p>
                    <p className={`text-sm ${darkMode ? 'text-white' : 'text-slate-800'}`}>
                      {new Date(member.birth_date).toLocaleDateString('pt-PT')}
                    </p>
                    {age !== null && <p className="text-xs text-blue-400 mt-1">{age} anos</p>}
                  </div>
                )}
                
                {member.nif && (
                  <p className={`text-xs mt-2 ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>NIF: {member.nif}</p>
                )}
                
                <div className="flex flex-wrap gap-1 mt-3">
                  {member.is_dependent && (
                    <span className="px-2 py-0.5 rounded text-xs bg-blue-500/20 text-blue-400">Dependente</span>
                  )}
                  {eligibleForChildBenefits && (
                    <span className="px-2 py-0.5 rounded text-xs bg-emerald-500/20 text-emerald-400">Elegível Abono</span>
                  )}
                  {eligibleForStudentBenefits && !eligibleForChildBenefits && (
                    <span className="px-2 py-0.5 rounded text-xs bg-purple-500/20 text-purple-400">Estudante</span>
                  )}
                  {age !== null && age >= 25 && (
                    <span className="px-2 py-0.5 rounded text-xs bg-amber-500/20 text-amber-400">Adulto</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FamilyTab;
